<template>
  <div>
    <video
      ref="videoPlayer"
      id="video"
      class="video-js vjs-big-play-centered"
      playsinline
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Hls from "hls.js";

export default {
  props: ["url", "lecture", "upperDisplay"],
  data() {
    return {
      player: null,
      hls: null,
      currentTraceTime: 0,
      videoProgressTime: 0,
    };
  },
  beforeDestroy() {
    this.clearPlayer();
  },
  methods: {
    clearPlayer() {
      if (this.player) {
        this.player.dispose({ restoreEl: true });
        this.player = null;
      }
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },
    renderVideoPlayer(url) {
      const seekTime = this.videoCurrentTime() / 1000;

      // If player exists, just update source instead of recreating
      if (this.player) {
        if (this.hls) {
          this.hls.destroy();
          this.hls = null;
        }

        if (url.endsWith(".m3u8") && Hls.isSupported()) {
          this.hls = new Hls();
          this.hls.loadSource(url);
          this.hls.attachMedia(this.$refs.videoPlayer);
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            if (seekTime > 0) this.$refs.videoPlayer.currentTime = seekTime;
            this.player.play();
          });
        } else {
          this.$refs.videoPlayer.src = url;
          if (seekTime > 0) this.$refs.videoPlayer.currentTime = seekTime;
          this.player.play();
        }
        return;
      }

      this.$nextTick(() => {
        const videoElement = this.$refs.videoPlayer;
        if (!videoElement) return;

        if (url.endsWith(".m3u8") && Hls.isSupported()) {
          this.hls = new Hls();
          this.hls.loadSource(url);
          this.hls.attachMedia(videoElement);
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            if (seekTime > 0) videoElement.currentTime = seekTime;
          });
        } else {
          videoElement.src = url;
          if (seekTime > 0) videoElement.currentTime = seekTime;
        }

        this.player = videojs(videoElement, {
          controls: true,
          preload: "auto",
          fluid: true,
          playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
        });

        this.registerPlayerEvents();
      });
    },
    registerPlayerEvents() {
      if (!this.player) return;

      this.player.on("timeupdate", () => {
        const truncTime = Math.trunc(this.player.currentTime());
        const cycleLog = 10;
        const isCycleRecord = truncTime % cycleLog === 0;
        const isNew = truncTime > this.currentTraceTime;

        if (isCycleRecord && isNew) {
          const payload = {
            key: this.upperDisplay.key,
            currenttime: truncTime * 1000,
            _id: this.lecture._id,
          };
          this.currentTraceTime = truncTime;
          this.$store.dispatch("closeVideo", payload);
          this.updateTimeCondition(truncTime);
        }
      });

      this.player.on("seeked", () => {
        const truncTime = Math.trunc(this.player.currentTime());
        const payload = {
          key: this.upperDisplay.key,
          currenttime: truncTime * 1000,
          _id: this.lecture._id,
        };
        this.currentTraceTime = truncTime;
        this.$store.dispatch("closeVideo", payload);
        this.updateTimeCondition(truncTime);
      });

      this.player.on("ended", () => {
        this.$store.dispatch("closeVideo", {
          key: this.upperDisplay.key,
          currenttime: this.upperDisplay.videoTime,
          _id: this.lecture._id,
        });
        this.$store.dispatch("fetchSections", this.$store.getters.courseId);
      });
    },
    videoCurrentTime() {
      if (
        this.upperDisplay.videoCurrentTime &&
        this.upperDisplay.videoCurrentTime !== this.upperDisplay.videoTime
      ) {
        let rewindVideo = this.upperDisplay.videoCurrentTime - 10000;
        return rewindVideo > 0 ? rewindVideo : 0;
      }
      return 0;
    },
    updateVideoProgressTime(time) {
      this.videoProgressTime = time;
    },
    updateTimeCondition(truncTime) {
      this.sendUpdateTimeToCourseList(truncTime * 1000);
      this.updateVideoProgressTime(truncTime * 1000);
    },
    sendUpdateTimeToCourseList(time) {
      let id = this.lecture._id;
      this.$store.commit("updateVideoTime", { id, time });
    },
  },
  mounted() {
    this.updateVideoProgressTime(this.upperDisplay.videoTime);
    this.renderVideoPlayer(this.url);
  },
  watch: {
    url(newUrl) {
      this.renderVideoPlayer(newUrl);
    },
  },
};
</script>
